import { C } from "../../shared/theme";
import { KindIcon } from "../../shared/kindIcons";
import { AddButton } from "../../shared/AddButton";

// Under Today's Plan: a way to Radar for when you don't know what to put in the day (Craig, 25 Oct 2026: "Need help
// deciding? <Radar> (green button)"). The button wears Radar's icon, as Home's tile and the bottom bar do.
export function HelpDeciding({ onRadar }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, flexWrap: "wrap", margin: "0 0 15px" }}>
      <span id="help-deciding" style={{ fontSize: 15, color: C.textMid }}>Need help deciding?</span>
      <AddButton onClick={onRadar} aria-describedby="help-deciding" icon={<KindIcon id="radar" size={18} />}>Radar</AddButton>
    </div>
  );
}
